import {Component, Input} from '@angular/core';
import {SectionHeaderTitleSize} from '@lib-modules/section/components/section-header/section-header.component';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {ISpecial} from '@api/models/specials/specials';

@Component({
  selector: 'lib-specials-section',
  templateUrl: './specials-section.component.html',
  styleUrls: ['./specials-section.component.scss']
})
export class SpecialsSectionComponent {


  @Input() public specials: ISpecial[];
  @Input() public title: string;
  @Input() public titleIcon: string;
  @Input() public titleSize = SectionHeaderTitleSize.Large;
  @Input() public colorScheme = ColorScheme.Dark;

  constructor() { }

}
